"use client"

import Link from "next/link"
import { LogOut, User2 } from "lucide-react"
import { useState, useEffect } from "react"

/**
 * Bottom-of-sidebar account widget for the custom Payload Nav.
 *
 * Renders the current admin's email + a "Se déconnecter" button. The
 * email is fetched from `/api/users/me` on mount (Payload's own
 * authenticated identity endpoint) so we don't have to plumb the user
 * down from the server Nav. If the lookup fails (network blip, session
 * expired), we fall back to a plain "Mon compte" label.
 */

type Me = {
  user?: {
    id?: string | number
    email?: string
    name?: string
  }
}

export function LogoutLink() {
  const [email, setEmail] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    fetch("/api/users/me", { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((j: Me | null) => {
        if (cancelled || !j?.user?.email) return
        setEmail(j.user.email)
      })
      .catch(() => {
        /* silent — fallback label is fine */
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="adis-nav__account">
      <Link
        href="/admin/account"
        className="adis-nav__account-info"
        title={email ?? "Mon compte"}
      >
        <span className="adis-nav__account-icon" aria-hidden>
          <User2 size={16} strokeWidth={1.75} />
        </span>
        <span className="adis-nav__account-text">
          <span className="adis-nav__account-label">Mon compte</span>
          {email ? (
            <span className="adis-nav__account-email">{email}</span>
          ) : null}
        </span>
      </Link>
      <Link
        href="/admin/logout"
        className="adis-nav__logout"
        aria-label="Se déconnecter"
        title="Se déconnecter"
      >
        <LogOut size={16} strokeWidth={1.75} />
      </Link>
    </div>
  )
}
